<template>
  <div class="dictionary-content" style="height:100%;background:#fff;border-radius:4px;padding:24px">
    <div>
      <span style="color:rgba(18, 18, 18, 1);font-size:16px;font-weight:bold;">字典内容</span>
      <div style="display:inline-block;float:right">
        <a-button @click="querySingleNum" type="primary">单号码查询</a-button>
        <a-dropdown style="margin:0 12px;" :trigger="['click']">
          <a-button type="primary">导出</a-button>
          <a-menu slot="overlay" style="text-align:center">
            <a-menu-item key="1" @click="outputAll">
              <div style="color:rgba(80, 80, 80, 1);font-size:14px;">导出全部</div>
              <div style="color:rgba(188, 188, 188, 1);font-size:12px;">（单次导出上限100000条）</div>
            </a-menu-item>
            <a-menu-divider />
            <a-menu-item key="2" @click="showOutputRecord">
              导出记录
            </a-menu-item>
          </a-menu>
        </a-dropdown>
        <a-dropdown :trigger="['click']">
          <a-button type="primary">新增号码</a-button>
          <a-menu slot="overlay" style="text-align:center">
            <a-menu-item key="1" @click="singleAddOperate">
              <div style="color:rgba(80, 80, 80, 1);font-size:14px;">单个新增</div>
              <div style="color:rgba(188, 188, 188, 1);font-size:12px;">（手动输入）</div>
            </a-menu-item>
            <a-menu-divider />
            <a-menu-item key="2" @click="multipleAddOperate">
              <div style="color:rgba(80, 80, 80, 1);font-size:14px;">批量新增</div>
              <div style="color:rgba(188, 188, 188, 1);font-size:12px;">（导入exel表格）</div>
            </a-menu-item>
          </a-menu>
        </a-dropdown>
        <a-button v-if="selectedRowKeys.length>0" type="primary" style="margin-left:12px;" ghost @click="deleteRecord">批量删除</a-button>
      </div>
    </div>
    <div style="margin-top:20px;">
      <div style="display:inline-block;">
        <div>字典名称</div>
        <a-select  placeholder="请选择" style="width: 280px;margin-top:8px;" v-model="dictionaryName">
          <a-select-option v-for="(item,index) in dictionaryNameList" :key='index' :value="item.value">
            {{item.name}}
          </a-select-option>
        </a-select>
      </div>
      <div style="display:inline-block;margin:0 80px;">
        <div>创建时间</div>
        <a-range-picker style="margin-top:8px;width:300px;" v-model="createTimeData"/>
      </div>
      <div style="display:inline-block;">
        <div>修改时间</div>
        <a-range-picker style="margin-top:8px;width:300px;" v-model="changeTime" />
      </div>
      <div style="float:right;margin-top:10px;margin-top:28px;">
        <span @click="resetCondition" style="display:inline-block;width:64px;height:32px;line-height:32px;text-align:center;cursor:pointer;background:#fff;color:rgba(121, 136, 155, 1);border:1px solid rgba(121, 136, 155, 1);border-radius:4px;font-size:14px;margin-right:12px;">重置</span>
        <span @click="queryBasicData(1)" style="display:inline-block;width:64px;height:32px;line-height:32px;text-align:center;cursor:pointer;background:rgba(121, 136, 155, 0.16);color:rgba(121, 136, 155, 1);border:1px solid rgba(121, 136, 155, 1);border-radius:4px;font-size:14px;">查询</span>
      </div>
    </div>
    <div style="margin-top:24px;">
      <a-table
          :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
          :data-source="msgInterfaceData"
          :pagination='false'
          rowKey="id"
          :scroll="{ y: 'calc(100vh - 390px)' }"
      >
        <a-table-column key="phone" title="号码" data-index="phone" />
        <a-table-column key="dictName" title="字典名称" data-index="dictName" >
          <template slot-scope="text, record">
            <div :title='record.dictName'>
              {{record.dictName}}
            </div>
          </template>
        </a-table-column>
        <a-table-column key="content" title="字典内容" data-index="content" >
         <template slot-scope="text, record">
            <div :title='record.content'>
              {{record.content.length>20?record.content.substring(0,20):record.content}}
            </div>
          </template>
        </a-table-column>
        <a-table-column key="createTime" title="创建时间" data-index="createTime" />
        <a-table-column key="updateTime" title="修改时间" data-index="updateTime" />
        <a-table-column key="id" title="操作" data-index="id">
          <template slot-scope="text, record">
            <div>
              <span class="operate-item" style="cursor:pointer;" @click="editWord(record)">编辑</span>
              <span class="operate-item" style="margin-left:12px;cursor:pointer" @click="deleteWord(record.id)">删除</span>
            </div>
          </template>
        </a-table-column>
      </a-table>
      <div class="pagination-table">
        <a-pagination
            class="pagination"
            show-size-changer
            :default-current="3"
            :total="total"
            @change="pageChange"
            @showSizeChange="onShowSizeChange"
        />
      </div>
    </div>
    <a-modal :centered='true' :maskClosable='false' v-model.trim="outputWarning" footer='' width='480px'>
      <div class="output-modal modal-public">
          <div class="sure-off-bind">
              <a-icon type="warning" />
              <span>导出数据已超过最大限度</span>
          </div>
          <div class="tip1">当前条件数据{{exportCount}}条，超过限制</div>
          <div class="tip2">请在查询区域，按时间段查询分次导出</div>
          <a-divider class="divider2" type="horizontal" />
          <div class="btn-group">
              <a-button type="primary" ghost @click="cancelOutput">取消</a-button>
              <a-button type="primary" @click="sureOutput">确定</a-button>
          </div>
      </div>
    </a-modal>
    <a-modal :centered='true' :maskClosable='false' v-model.trim="completeTip" footer='' width='480px'>
      <div class="output-modal modal-public">
          <div class="sure-off-bind">
              <a-icon style="color:rgba(66, 223, 228, 1)" type="check-circle" />
              <span>导出数据任务已完成</span>
          </div>
          <div class="tip1">共计算出数据：{{exportCount}}条</div>
          <div class="tip2">
            <span>您可前往</span>
            <span @click="viewOutputDetail" style="color:rgba(66, 223, 228, 1);margin:0 4px;cursor:pointer">导出——导出记录</span>
            <span>查看进度详情</span>
          </div>
          <div class="tip2" style="margin-top:10px;">并在任务完成后进行下载</div>
          <a-divider class="divider2" type="horizontal" />
          <div class="btn-group">
              <a-button type="primary" ghost @click="cancelComplete">取消</a-button>
              <a-button type="primary" @click="sureComplete">确定</a-button>
          </div>
      </div>
    </a-modal>
    <a-modal :centered='true' :maskClosable='false' v-model.trim="outputRecordBool" title="导出记录" footer='' width='1120px'>
      <div class="record-modal modal-public">
        <a-divider class="divider1" type="horizontal" />
        <div>
          <span>创建时间：</span>
          <a-range-picker @change="dateChange" />
        </div>
        <a-table rowKey="downloadUrl" style="margin-top:16px;" :data-source="outputData" :pagination='false' :loading="ifShowLoading" :scroll="{ y: 340 }">
          <a-table-column key="createTime" title="创建时间" data-index="createTime" />
          <a-table-column key="exportCount" title="导出数据量" data-index="exportCount" />
          <a-table-column key="status" title="进度" data-index="status">
              <template slot-scope="text, record">
                  <div v-if="record.status==1">
                      <span style="width:8px;height:8px;border-radius:4px;background:rgba(255, 195, 0, 1);display:inline-block;margin-right:8px;"></span>
                      <span>待执行</span>
                  </div>
                  <div v-if="record.status==2">
                      <span style="width:8px;height:8px;border-radius:4px;background:rgba(24, 144, 255, 1);display:inline-block;margin-right:8px;"></span>
                      <span>执行中</span>
                  </div>
                  <div v-if="record.status==3">
                      <span style="width:8px;height:8px;border-radius:4px;background:rgba(67, 207, 124, 1);display:inline-block;margin-right:8px;"></span>
                      <span>已完成</span>
                  </div>
              </template>
          </a-table-column>
          <a-table-column key="downloadUrl" title="附件" data-index="downloadUrl">
              <template slot-scope="text, record">
                  <div v-if="record.downloadUrl!=''">
                      <a :href="record.downloadUrl" style="cursor:pointer;color:#1890FF;">
                          <a-icon style="color:#1890FF;font-size:20px;;" type="download" />
                          下载
                      </a>
                  </div>
              </template>
          </a-table-column>
        </a-table>
        <a-divider class="divider2" type="horizontal" />
        <div class="btn-group">
          <a-button type="primary" ghost @click="cancelRecordBool">取消</a-button>
          <a-button type="primary" @click="sureRecordBool">确定</a-button>
        </div>
      </div>
    </a-modal>
    <a-modal :centered='true' :maskClosable='false' v-model.trim="deleteDictionariesBool1" footer='' width='480px'>
      <div class="delete-modal modal-public">
          <div class="sure-off-bind">
              <a-icon type="warning" />
              <span>您确定要删除这些数据吗？</span>
          </div>
          <div class="tip">删除后，数据无法恢复</div>
          <a-divider class="divider2" type="horizontal" />
          <div class="btn-group">
              <a-button type="primary" ghost @click="cancelDelete1">取消</a-button>
              <a-button type="primary" @click="sureDelete1">确定</a-button>
          </div>
      </div>
    </a-modal>
    <a-modal :centered='true' :maskClosable='false' v-model.trim="deleteDictionariesBool2" footer='' width='480px'>
      <div class="delete-modal modal-public">
          <div class="sure-off-bind">
              <a-icon type="warning" />
              <span>您确定要删除这条数据吗？</span>
          </div>
          <div class="tip">删除后，数据无法恢复</div>
          <a-divider class="divider2" type="horizontal" />
          <div class="btn-group">
              <a-button type="primary" ghost @click="cancelDelete2">取消</a-button>
              <a-button type="primary" @click="sureDelete2">确定</a-button>
          </div>
      </div>
    </a-modal>
    <a-modal :centered='true' :maskClosable='false' v-model.trim="outputWordModal" title="导出-选择字段" footer='' width='560px'>
      <div class="output-word-modal modal-public">
          <a-divider class="divider1" type="horizontal" />
          <div class="select-all-word">
              <a-checkbox @change="selectAllWord1" :checked="checkAll1">
                  全选
              </a-checkbox>
          </div>
          <div class="word-list">
              <a-checkbox-group @change="selectItemWord1" style="width:100%" v-model="checkedWordList1">
                  <a-row style="margin-bottom:0px">
                      <a-col :span="6" v-for="(item, index) in fieldList" :key="index">
                          <a-checkbox :value="item.value"  >
                              {{item.label}}
                          </a-checkbox>
                      </a-col>
                  </a-row>
              </a-checkbox-group>
          </div>
          <a-divider class="divider3" type="horizontal" />
          <div class="btn-group">
              <a-button type="primary" ghost @click="cancelSelectWords">取消</a-button>
              <a-button type="primary" @click="sureSelectWords">下一步</a-button>
          </div>
      </div>
    </a-modal>
    <a-modal :centered='true' :maskClosable='false' v-model.trim="singleNumBool" title="单号码查询" footer='' width='600px'>
      <div class="single-modal modal-public">
        <a-divider class="divider1" type="horizontal" />
        <div class="changed-name">输入号码：</div>
        <div>
          <a-input v-model="singleNumber" style="display:inline-block;width:300px;" placeholder="请输入号码" />
          <div style="display:inline-block;float:right;margin-top:8px;">
            <span @click="resetSingleNum" style="display:inline-block;width:64px;height:32px;line-height:32px;text-align:center;cursor:pointer;background:#fff;color:rgba(121, 136, 155, 1);border:1px solid rgba(121, 136, 155, 1);border-radius:4px;font-size:14px;margin-right:12px;">重置</span>
            <span @click="querySinglePhone" style="display:inline-block;width:64px;height:32px;line-height:32px;text-align:center;cursor:pointer;background:rgba(121, 136, 155, 0.16);color:rgba(121, 136, 155, 1);border:1px solid rgba(121, 136, 155, 1);border-radius:4px;font-size:14px;">查询</span>
          </div>
        </div>
        <a-divider class="divider2" type="horizontal" />
        <div style="font-size:24px;font-weight:bold;">{{singlePhoneData.phone}}</div>
        <div class="word-list">
          <span v-for="(item,index) in singlePhoneData.itemList" :key='index'>{{item.dictName}}: {{item.content}}</span>
        </div>
      </div>
    </a-modal>
    <a-modal :centered='true' :maskClosable='false' v-model.trim="editBool" title="编辑" footer='' width='560px'>
      <div class="edit-modal modal-public">
        <a-divider class="divider1" type="horizontal" />
        <div style="color:rgba(18, 18, 18, 1);font-size:14px;font-weight:bold">号码</div>
        <div style="color:rgba(18, 18, 18, 1);font-size:14px;margin-top:8px;">{{editContent.phone}}</div>
        <a-divider class="divider2" style="margin-bottom:24px;" type="horizontal" />
        <div style="color:rgba(18, 18, 18, 1);font-size:14px;font-weight:bold">字典</div>
        <div style="color:rgba(18, 18, 18, 1);font-size:14px;margin-top:8px;">
          <span style="display:inline-block;width:100px;">{{editContent.dictName}}：</span>
          <a-input v-model="editContent.content" style="display:inline-block;width:350px;" placeholder="请输入姓名" />
        </div>
        <a-divider class="divider2" type="horizontal" />
        <div class="btn-group">
          <a-button type="primary" ghost @click="cancelEditWords">取消</a-button>
          <a-button type="primary" @click="sureEditWords">确定</a-button>
        </div>
      </div>
    </a-modal>
    <a-modal :centered='true' :maskClosable='false' v-model.trim="singleAddModal" title="单个新增-选择字段" footer='' width='560px'>
      <div class="output-word-modal modal-public">
          <a-divider class="divider1" type="horizontal" />
          <div class="select-all-word">
              <a-checkbox @change="selectAllWord2" :checked="checkAll2">
                  全选
              </a-checkbox>
          </div>
          <div class="word-list">
              <a-checkbox-group @change="selectItemWord2" style="width:100%" v-model="checkedWordList2">
                  <a-row style="margin-bottom:0px">
                      <a-col :span="6" v-for="(item, index) in dictionaryNameList" :key="index">
                          <a-checkbox :value="item.value"  >
                              {{item.name}}
                          </a-checkbox>
                      </a-col>
                  </a-row>
              </a-checkbox-group>
          </div>
          <a-divider class="divider3" type="horizontal" />
          <div class="btn-group">
              <a-button type="primary" ghost @click="cancelAddSingleWords">取消</a-button>
              <a-button type="primary" @click="sureAddSingleWords">下一步</a-button>
          </div>
      </div>
    </a-modal>
    <a-modal :centered='true' :maskClosable='false' v-model.trim="multipleAddModal" title="批量新增-选择字段" footer='' width='560px'>
      <div class="output-word-modal modal-public">
          <a-divider class="divider1" type="horizontal" />
          <div class="select-all-word">
              <a-checkbox @change="selectAllWord3" :checked="checkAll3">
                  全选
              </a-checkbox>
          </div>
          <div class="word-list">
              <a-checkbox-group @change="selectItemWord3" style="width:100%" v-model="checkedWordList3">
                  <a-row style="margin-bottom:0px">
                      <a-col :span="6" v-for="(item, index) in dictionaryNameList" :key="index">
                          <a-checkbox :value="item.value">
                              {{item.name}}
                          </a-checkbox>
                      </a-col>
                  </a-row>
              </a-checkbox-group>
          </div>
          <a-divider class="divider3" type="horizontal" />
          <div class="btn-group">
              <a-button type="primary" ghost @click="cancelAddMultipleWords">取消</a-button>
              <a-button type="primary" @click="sureAddMultipleWords">下一步</a-button>
          </div>
      </div>
    </a-modal>
    <a-modal :centered='true' :maskClosable='false' v-model.trim="oneAddBool" title="单个新增" footer='' width='560px'>
      <div class="single-modal modal-public">
        <a-divider class="divider1" type="horizontal" />
        <div style="color:rgba(18, 18, 18, 1);font-size:14px;font-weight:bold">号码：</div>
        <div>
          <span>输入号码：</span>
          <a-input v-model="singleNumberData" style="display:inline-block;width:300px;margin-left:8px;" placeholder="请输入号码" />
          <div style="display:inline-block;float:right;margin-top:8px;">
            <span @click="querySingleDictionary" style="display:inline-block;width:64px;height:32px;line-height:32px;text-align:center;cursor:pointer;background:rgba(121, 136, 155, 0.16);color:rgba(121, 136, 155, 1);border:1px solid rgba(121, 136, 155, 1);border-radius:4px;font-size:14px;">查询</span>
          </div>
        </div>
        <a-divider class="divider2" type="horizontal" />
        <div style="color:rgba(18, 18, 18, 1);font-size:14px;font-weight:bold">字典：</div>
        <div v-for="(item,index) in singleDictionaryList" :key='index' style="margin-bottom:12px;">
          <span style="display:inline-block;width:100px;">{{item.name}}：</span>
          <a-input v-model="item.value" style="display:inline-block;width:350px;" placeholder="请输入短信内容" />
        </div>
        <a-divider class="divider2" type="horizontal" />
        <div class="btn-group">
          <a-button type="primary" ghost @click="cancelAddOneWord">上一步</a-button>
          <a-button type="primary" @click="sureAddOneWord">确定</a-button>
        </div>
      </div>
    </a-modal>
    <a-modal :centered='true' :maskClosable='false' v-model.trim="batchAddModal" title="批量新增" footer='' width='560px'>
      <div class="normal-modal modal-public">
        <a-divider class="divider1" type="horizontal" />
        <div class="tab-normal">
          <div>
            <span style="color:rgba(80, 80, 80, 1);font-size:14px">*为保证数据导入顺利，请先</span>
            <a-button @click="downloadTemplate" icon="download" style="margin-left:8px">
            下载模板
            </a-button>
          </div>
          <div style="height:166px;margin-top:24px">
              <a-upload-dragger
                  key={Math.random()}
                  name="file"
                  :multiple="false"
                  :customRequest="customRequest"
                  @change="onUpload"
                  ref="pathClear"
              >
                  <p class="ant-upload-drag-icon">
                  <a-icon type="upload" />
                  </p>
                  <p class="ant-upload-text">
                  点击或将文件拖拽到这里上传
                  </p>
                  <p class="ant-upload-hint">
                  支持扩展名：.xls .xlsx
                  </p>
              </a-upload-dragger>
          </div>
        </div>
        <a-divider class="divider2" type="horizontal" />
        <div class="btn-group">
          <a-button type="primary" ghost @click="cancelBatchAdd">上一步</a-button>
          <a-button type="primary" @click="sureBatchAdd">确认</a-button>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import moment from 'moment'
export default {
  name: 'DictionaryContent',
  props: {
    msg: String
  },
   data() {
    return {
      outputWarning: false,
      completeTip: false,
      outputRecordBool: false,
      outputData: [],
      ifShowLoading: false,
      selectedRowKeys: [],
      total: 0,
      currentPage: 1,
      pageSize: 10,
      deleteDictionariesBool1: false,
      deleteDictionariesBool2: false,
      outputWordModal: false,
      checkAll1: false,
      checkedWordList1: [],
      fieldList: [],
      singleNumBool: false,
      editBool: false,
      singleAddModal: false,
      checkAll2: false,
      checkedWordList2: [],
      multipleAddModal: false,
      checkAll3: false,
      checkedWordList3: [],
      oneAddBool: false,
      batchAddModal: false,
      currentId: '',
      newFormData: '',
      dictionaryName: undefined,
      createTimeData: null,
      changeTime: null,
      msgInterfaceData: [],
      dictionaryNameList: [],
      startTime: '',
      endTime: '',
      singleNumber: '',
      singlePhoneData: '',
      singleDictionaryList: [],
      singleNumberData: '',
      editContent: '',
      deleteId: '',
      exportCount: 0
    }
  },
  methods: {
    moment,
    outputAll() {
      let minCreateTime = '', maxCreateTime = '', minUpdateTime = '', maxUpdateTime = ''
      if(this.createTimeData != null){
        minCreateTime = moment(this.createTimeData[0], 'YYYY-MM-DD').format('YYYY-MM-DD')
        maxCreateTime = moment(this.createTimeData[1], 'YYYY-MM-DD').format('YYYY-MM-DD')
      }
      if(this.changeTime != null){
        minUpdateTime = moment(this.changeTime[0], 'YYYY-MM-DD').format('YYYY-MM-DD')
        maxUpdateTime = moment(this.changeTime[1], 'YYYY-MM-DD').format('YYYY-MM-DD')
      }
      this.axios.post('/api/dictItem/export',{
        dictId: this.dictionaryName,
        minCreateTime: minCreateTime,
        maxCreateTime: maxCreateTime,
        minUpdateTime: minUpdateTime,
        maxUpdateTime: maxUpdateTime
      })
      .then(response=> {
        if(response.data.code == 0){
          this.queryExportNum()
          this.completeTip = true
        }else if(response.data.code == 'A0002'){
          this.queryExportNum()
          this.outputWarning = true
          // if(response.data.code == 'A0200'){
          //   this.$router.push("/Login")
          // }
        }else{
          this.$message.error(response.data.userTip)
        }
      })
      .catch(error=> {
          console.log(error)
      })
    },
    queryExportNum() {
      let minCreateTime = '', maxCreateTime = '', minUpdateTime = '', maxUpdateTime = ''
      if(this.createTimeData != null){
        minCreateTime = moment(this.createTimeData[0], 'YYYY-MM-DD').format('YYYY-MM-DD')
        maxCreateTime = moment(this.createTimeData[1], 'YYYY-MM-DD').format('YYYY-MM-DD')
      }
      if(this.changeTime != null){
        minUpdateTime = moment(this.changeTime[0], 'YYYY-MM-DD').format('YYYY-MM-DD')
        maxUpdateTime = moment(this.changeTime[1], 'YYYY-MM-DD').format('YYYY-MM-DD')
      }
      this.axios.post('/api/dictItem/export/count', {
        dictId: this.dictionaryName,
        minCreateTime: minCreateTime,
        maxCreateTime: maxCreateTime,
        minUpdateTime: minUpdateTime,
        maxUpdateTime: maxUpdateTime
      })
      .then(response=> {
        if(response.data.code == 0){
          this.exportCount = response.data.data.exportCount
        }else{
          this.$message.error(response.data.userTip);
          // if(response.data.code == 'A0200'){
          //   this.$router.push("/Login")
          // }
        }
      })
      .catch(error=> {
        console.log(error);
      });
    },
    cancelOutput() {
      this.outputWarning = false
    },
    sureOutput() {
      this.outputWarning = false
    },
    cancelComplete() {
      this.completeTip = false
    },
    sureComplete() {
      this.completeTip = false
    },
    showOutputRecord() {
      this.outputRecordBool = true
      this.queryOutputData()
    },
    cancelRecordBool() {
      this.outputRecordBool = false
    },
    sureRecordBool() {
      this.outputRecordBool = false
    },
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys;
    },
    pageChange(current, pageSize) {
      this.currentPage = current
      this.pageSize = pageSize
      this.queryBasicData(2)
    },
    onShowSizeChange(current, pageSize) {
      this.currentPage = current
      this.pageSize = pageSize
      this.queryBasicData(2)
    },
    deleteRecord() {
      if(this.selectedRowKeys.length == 0){
        this.$message.warning('请先选择需要删除的选项')
      }else{
        this.deleteDictionariesBool1 = true
      }
    },
    cancelDelete1() {
      this.deleteDictionariesBool1 = false
    },
    sureDelete1() {
      this.deleteDictionariesBool1 = false
      this.axios.post('/api/dictItem/delete', {
        idList: this.selectedRowKeys,
      })
      .then(response=> {
        if(response.data.code == 0){
          this.$message.success('删除成功')
          this.queryBasicData(2)
        }else{
          this.$message.error(response.data.userTip);
          // if(response.data.code == 'A0200'){
          //   this.$router.push("/Login")
          // }
        }
      })
      .catch(error=> {
        console.log(error);
      });
    },
    cancelDelete2() {
      this.deleteDictionariesBool2 = false
    },
    sureDelete2() {
      this.deleteDictionariesBool2 = false
      let arr = []
      arr.push(this.deleteId)
      this.axios.post('/api/dictItem/delete', {
        idList: arr,
      })
      .then(response=> {
        if(response.data.code == 0){
          this.$message.success('删除成功')
          this.queryBasicData(2)
        }else{
          this.$message.error(response.data.userTip);
          // if(response.data.code == 'A0200'){
          //   this.$router.push("/Login")
          // }
        }
      })
      .catch(error=> {
        console.log(error);
      });
    },
    selectAllWord1(e) {
      this.checkedWordList1 = []
      if(e.target.checked) {
          this.checkAll1 = true
          for(let i = 0; i < this.fieldList.length; i++){
              this.checkedWordList1.push(this.fieldList[i]['value'])
          }
      }else{
          this.checkAll1 = false
      }
    },
    selectItemWord1(e) {
      this.checkedWordList1 = e
      if(this.checkedWordList1.length == this.fieldList.length) {
          this.checkAll1 = true
      }else{
          this.checkAll1 = false
      } 
    },
    cancelSelectWords() {
      this.outputWordModal = false
    },
    sureSelectWords() {
      this.outputWordModal = false
      
    },
    querySingleNum() {
      this.singleNumBool = true
    },
    editWord(data) {
      this.editBool = true
      this.editContent = data
    },
    deleteWord(id) {
      this.deleteId = id
      this.deleteDictionariesBool2 = true
    },
    cancelEditWords() {
      this.editBool = false
    },
    sureEditWords() {
      this.editBool = false
      this.axios.post('/api/dictItem/edit', {
        id: this.editContent.id,
        content: this.editContent.content
      })
      .then(response=> {
        if(response.data.code == 0){
          this.$message.success('编辑成功')
        }else{
          this.$message.error(response.data.userTip);
          // if(response.data.code == 'A0200'){
          //   this.$router.push("/Login")
          // }
        }
      })
      .catch(error=> {
        console.log(error);
      });
    },
    cancelAddSingleWords() {
      this.singleAddModal = false
    },
    querySingleDictionary() {
      let str = ''
      for(let i = 0; i < this.checkedWordList2.length; i++){
        str += this.checkedWordList2[i] + ','
      }
      str = str.substr(0, str.length - 1)
      this.axios(
        {
          method:'get',
          url:'/api/dictItem/single', 
          params: {
            phone: this.singleNumberData,
            dictIds: str
          }
        }
      )
      .then(response=> {
        if(response.data.code == 0){
          let arr = response.data.data.itemList
          for(let i = 0; i < this.singleDictionaryList.length; i++){
            for(let j = 0; j < arr.length; j++){
              if(this.singleDictionaryList[i]['id'] == arr[j]['dictId']){
                this.singleDictionaryList[i]['value'] = arr[j]['content']
              }
            }
          }
        }else{
          this.$message.error(response.data.userTip);
          // if(response.data.code == 'A0200'){
          //     this.$router.push("/Login")
          // }
        }
      })
      .catch(error=> {
        console.log(error)
      })
    },
    sureAddSingleWords() {
      this.singleDictionaryList = []
      if(this.checkedWordList2.length == 0){
        this.$message.error('请先选择字段')
      }else{
        this.singleAddModal = false
        this.oneAddBool = true
        for(let i = 0; i < this.dictionaryNameList.length; i++){
          for(let j = 0; j < this.checkedWordList2.length; j++){
            if(this.dictionaryNameList[i]['value'] == this.checkedWordList2[j]){
              let obj = {}
              obj.name = this.dictionaryNameList[i].name
              obj.id = this.dictionaryNameList[i].value
              obj.value = ''
              this.singleDictionaryList.push(obj)
            }
          }
        }
      }
      
    },
    selectAllWord2(e) {
      this.checkedWordList2 = []
      if(e.target.checked) {
          this.checkAll2 = true
          for(let i = 0; i < this.dictionaryNameList.length; i++){
              this.checkedWordList2.push(this.dictionaryNameList[i]['value'])
          }
      }else{
          this.checkAll2 = false
      }
    },
    selectItemWord2(e) {
      this.checkedWordList2 = e
      if(this.checkedWordList2.length == this.dictionaryNameList.length) {
          this.checkAll2 = true
      }else{
          this.checkAll2 = false
      } 
    },
    singleAddOperate() {
      this.singleAddModal = true
    },
    cancelAddMultipleWords() {
      this.multipleAddModal = false
    },
    sureAddMultipleWords() {
      this.multipleAddModal = false
      this.batchAddModal = true
    },
    selectAllWord3(e) {
      this.checkedWordList3 = []
      if(e.target.checked) {
          this.checkAll3 = true
          for(let i = 0; i < this.dictionaryNameList.length; i++){
              this.checkedWordList3.push(this.dictionaryNameList[i]['value'])
          }
      }else{
          this.checkAll3 = false
      }
    },
    selectItemWord3(e) {
      this.checkedWordList3 = e
      if(this.checkedWordList3.length == this.dictionaryNameList.length) {
          this.checkAll3 = true
      }else{
          this.checkAll3 = false
      } 
    },
    multipleAddOperate() {
      this.multipleAddModal = true
    },
    cancelAddOneWord() {
      this.oneAddBool = false
      this.singleAddModal = true
    },
    sureAddOneWord() {
      this.oneAddBool = false
      let arr = []
      for(let i = 0; i < this.singleDictionaryList.length; i++){
        let obj = {}
        obj.dictId = this.singleDictionaryList[i]['id']
        obj.content = this.singleDictionaryList[i]['value']
        arr.push(obj)
      }
      this.axios.post('/api/dictItem', {
        phone: this.singleNumberData,
        itemList: arr
      })
      .then(response=> {
        if(response.data.code == 0){
          this.$message.success('新增成功')
        }else{
          this.$message.error(response.data.userTip);
          // if(response.data.code == 'A0200'){
          //   this.$router.push("/Login")
          // }
        }
      })
      .catch(error=> {
        console.log(error);
      });
    },
    downloadTemplate() {
      // window.open('/api/waitingCall/download/template/'+this.currentId, '_blank');
      if(this.checkedWordList3.length == 0){
        this.$message.error('请先选择字段');
      }else{
        let str = ''
        for(let i = 0; i < this.checkedWordList3.length; i++){
          str += this.checkedWordList3[i] + ','
        }
        str = str.substr(0, str.length - 1)
        window.open('/api/dictItem/downloadTemplate?dictIds='+str, '_blank');
      }
    },
    customRequest(data) { // 上传提交
      this.newFormData = ''
      const formData = new FormData() 
      formData.append('file', data.file)
      this.newFormData = formData
    },
    onUpload() {
      this.$refs.pathClear.value = ''
    },
    cancelBatchAdd() {
      this.batchAddModal = false
      this.multipleAddModal = true
    },
    sureBatchAdd() {
      this.batchAddModal = false
      this.axios({
        method: 'post',
        url: '/api/dictItem/import',
        headers:{
          'Content-Type':'application/x-www-form-urlencoded'
        },
        data: this.newFormData,
      }).then((response) => {
        if(response.data.code == 0){
          this.$message.success('导入成功')
          this.newFormData = ''
        }else{
          this.$message.error(response.data.userTip);
          // if(response.data.code == 'A0200'){
          //   this.$router.push("/Login")
          // }
        }
      }).catch(function (error) {
        console.log(error)
      })
    },
    queryDictionaryNameList() {
      this.axios(
        {
          method:'get',
          url:'/api/dict/selectList', 
        }
      )
      .then(response=> {
        if(response.data.code == 0){
          this.dictionaryNameList = response.data.data
        }else{
          this.$message.error(response.data.userTip);
          // if(response.data.code == 'A0200'){
          //     this.$router.push("/Login")
          // }
        }
      })
      .catch(error=> {
        console.log(error)
      })
    },
    resetCondition() {
      this.dictionaryName = undefined
      this.createTimeData = null
      this.changeTime = null
    },
    queryBasicData(type) {
      let minCreateTime = '', maxCreateTime = '', minUpdateTime = '', maxUpdateTime = ''
      if(this.createTimeData != null){
        minCreateTime = moment(this.createTimeData[0], 'YYYY-MM-DD').format('YYYY-MM-DD')
        maxCreateTime = moment(this.createTimeData[1], 'YYYY-MM-DD').format('YYYY-MM-DD')
      }
      if(this.changeTime != null){
        minUpdateTime = moment(this.changeTime[0], 'YYYY-MM-DD').format('YYYY-MM-DD')
        maxUpdateTime = moment(this.changeTime[1], 'YYYY-MM-DD').format('YYYY-MM-DD')
      }
      if(type == 1){
        this.currentPage = 1
      }
      this.axios(
        {
          method:'get',
          url:'/api/dictItem/list', 
          params: {
            current: this.currentPage,
            size: this.pageSize,
            dictId: this.dictionaryName,
            minCreateTime: minCreateTime,
            maxCreateTime: maxCreateTime,
            minUpdateTime: minUpdateTime,
            maxUpdateTime: maxUpdateTime
          }
        }
      )
      .then(response=> {
        if(response.data.code == 0){
          this.msgInterfaceData = response.data.data.records
          this.total = response.data.data.total
        }else{
          this.$message.error(response.data.userTip);
          // if(response.data.code == 'A0200'){
          //   this.$router.push("/Login")
          // }
        }
      })
      .catch(error=> {
          console.log(error)
      })
    },
    dateChange(date, dateString) {
      this.startTime = dateString[0]
      this.endTime = dateString[1]
      this.queryOutputData()
    },
    queryOutputData() {
      this.axios(
        {
          method:'get',
          url:'/api/dictItem/export/list', 
          params: {
            minCreateTime: this.startTime,
            maxCreateTime: this.endTime
          }
        }
      )
      .then(response=> {
        if(response.data.code == 0){
          this.outputData = response.data.data.records
        }else{
          this.$message.error(response.data.userTip);
          // if(response.data.code == 'A0200'){
          //   this.$router.push("/Login")
          // }
        }
      })
      .catch(error=> {
        console.log(error)
      })
    },
    viewOutputDetail() {
      this.completeTip = false
      this.outputRecordBool = true
      this.queryOutputData()
    },
    resetSingleNum() {
      this.singleNumber = ''
    },
    querySinglePhone() {
      this.axios(
        {
          method:'get',
          url:'/api/dictItem/single', 
          params: {
            phone: this.singleNumber,
          }
        }
      )
      .then(response=> {
        if(response.data.code == 0){
          this.singlePhoneData = response.data.data
        }else{
          this.$message.error(response.data.userTip);
          // if(response.data.code == 'A0200'){
          //     this.$router.push("/Login")
          // }
        }
      })
      .catch(error=> {
        console.log(error)
      })
    },

  },
  mounted: function() {
    this.sessionData('set','contentNavItem','DictionaryContent');
    this.queryDictionaryNameList()
  }
}
</script>

<style scoped lang="less">
  .dictionary-content{
    .pagination-table{
      padding-top: 24px;
      .total-info{
        float: left;
        color:rgba(121, 136, 155, 1);
        font-size: 14px;
      }
      .pagination{
        float: right;
      }
    }
    .operate-item:hover{
      color: #42DFE4;
    }
  }
  
  .modal-public{
    .divider1{
        margin: 0px 0 24px 0;
    }
    .divider2{
        margin: 24px 0 12px;
    }
    .btn-group{
      float: right;
      button{
          // width: 64px;
          height: 32px;
          font-size: 14px;
      }
      button:nth-child(1){
          margin-right: 16px;
      }
    }
    .btn-group2{
      float: right;
      button{
          // width: 64px;
          height: 32px;
          font-size: 14px;
      }
      button:nth-child(1){
          background: #fff;
          color: rgba(121, 136, 155, 0.7);
          border: 1px solid rgba(121, 136, 155, 0.5);
          margin-right: 16px;
      }
      button:nth-child(1):hover{
          background: rgba(121, 136, 155, 0.08);
      }
    }
  }
  .output-modal{
    padding-top: 24px;
    padding-bottom: 44px;
    .sure-off-bind{
        i{
            color: rgba(255, 170, 0, 1);
            font-size: 24px;
        }
        span{
            color: rgba(18, 18, 18, 1);
            font-size: 20px;
            margin-left: 24px;
        }
    }
    .tip1{
        color: rgba(80, 80, 80, 1);
        padding-left: 50px;
        margin: 24px 0 10px 0;
        color: rgba(80, 80, 80, 1);
        font-size: 14px;
    }
    .tip2{
        color: rgba(80, 80, 80, 1);
        padding-left: 50px;
        color: rgba(80, 80, 80, 1);
        font-size: 14px;
    }
  }
  .record-modal{
    padding-bottom: 44px;
    .changed-name{
      color: rgba(153, 153, 153, 1);
      font-size: 14px;
    }
    input{
      margin-top: 8px;
    }
  }
  .delete-modal{
    padding-top: 24px;
    padding-bottom: 44px;
    .sure-off-bind{
        i{
            color: rgba(255, 170, 0, 1);
            font-size: 24px;
        }
        span{
            color: rgba(18, 18, 18, 1);
            font-size: 20px;
            margin-left: 24px;
        }
    }
    .tip{
        color: rgba(80, 80, 80, 1);
        padding-left: 50px;
        margin: 24px 0;
    }
  }
  .output-word-modal{
    padding-bottom: 48px;
    .select-all-word{
        margin-bottom: 12px;
    }
    .word-list{
        div{
            margin-bottom: 13px;
        }
    }
  }
  .single-modal{
    padding-bottom: 44px;
    .changed-name{
      color: rgba(153, 153, 153, 1);
      font-size: 14px;
    }
    input{
      margin-top: 8px;
    }
    .word-list{
      span{
        display: inline-block;
        padding: 0 12px;
        height: 32px;
        line-height: 32px;
        margin-right: 12px;
        color: rgba(121, 136, 155, 1);
        font-size: 14px;
        margin-top: 12px;
        background: rgba(240, 242, 243, 1);
        border-radius: 4px;
      }
    }
  }
  .edit-modal{
    padding-bottom: 44px;
    .changed-name{
      color: rgba(153, 153, 153, 1);
      font-size: 14px;
    }
  }
  .normal-modal{
    padding-bottom: 46px;
    .tab-normal{
      height: 225px;
    }
  }
</style>
